import styled from '@emotion/styled';
import Image from 'next/image';
import Link from 'next/link';
import heroBgMobile from '../comm/images/hero-bg-mobile.png';
import heroBg from '../comm/images/hero-bg.png';
import { InlineBlock } from '@/components/comm/InlineBlock';
import { Section } from '@/components/pages/about/comm/Layout';
import useCustomBreakpoint, { breakpointMdSmall } from '@/components/pages/about/comm/lib/custom-breakpoint.service';
import { buttonStyle } from '@/components/pages/about/styles/button';
import { title03 } from '@/components/pages/about/styles/typography';
import { breakpointMedium } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';
import icTitleEdit from '@/public/images/ic-title-edit.svg';

const HeroSection = () => {
  const breakpoint = useCustomBreakpoint();

  return (
    <StyledSectionContainer>
      <StyledSectionInner>
        <TextContainer>
          <TitleText>
            <span>
              번거로운 코딩테스트부터 <InlineBlock>채용 우대까지</InlineBlock>
            </span>
            <strong>프로그래머스 자격증 하나로 해결하세요.</strong>
          </TitleText>
          <div>
            <Link href="/tryouts">
              <CtaButton>
                <CtaButtonText>
                  시험 접수하기
                  <Image
                    width={24}
                    height={24}
                    src={icTitleEdit}
                    alt="시험 접수하기"
                  />
                </CtaButtonText>
              </CtaButton>
            </Link>
          </div>
        </TextContainer>
        <Image src={(breakpoint === 'mdSmall' || breakpoint === 'sm') ? heroBgMobile : heroBg} alt="" />
      </StyledSectionInner>
    </StyledSectionContainer>
  );
};

export default HeroSection;

const StyledSectionContainer = styled(Section.Container)`
overflow: hidden;
`;

const StyledSectionInner = styled(Section.Inner)`
position: relative;
display: flex;
max-width: 1200px;
height: 520px;
align-items: center;
justify-content: space-between;
padding: 0 16px;

@media (max-width: ${breakpointMedium}) {
  height: 400px;
}

@media (max-width: ${breakpointMdSmall}) {
  height: 340px;
  padding: 0 0 0 16px;
  padding-right: 0;
  margin-right: 0;
}

> img {
  position: absolute;
  top: 0;
  right: 0;
  width: 675px;
  height: auto;
  margin-right: -74px;

  @media (max-width: ${breakpointMedium}) {
    width: 520px;
  }

  @media (max-width: ${breakpointMdSmall}) {
    width: 155px;
    margin-right: 0;
  }
}

`;

const TextContainer = styled.div`
display: flex;
width: calc(100% - 527px);
flex-direction: column;
align-items: flex-start;
gap: 32px;

@media (max-width: ${breakpointMedium}) {
  width: calc(100% - 381px);
  gap: 24px;
}

@media (max-width: ${breakpointMdSmall}) {
  width: calc(100% - 123px)
}
`;

const TitleText = styled.div`
  display: grid;
  align-self: start;

  color: ${colors.textPrimary};
  font-size: 32px;
  font-weight: 500;
  letter-spacing: -1px;
  line-height: 140%;
  word-break: keep-all;

  > strong {
    font-weight: 700;
  }

  @media (max-width: ${breakpointMedium}) {
    font-size: 24px;
  }

  @media (max-width: ${breakpointMdSmall}) {
    font-size: 22px;
  }
`;

const CtaButton = styled.button`
  ${buttonStyle.primary}
  min-width: max-content;
  padding: 15px 20px 15px 24px;

  @media (max-width: ${breakpointMedium}) {
    padding: 12px 20px 12px 24px;
  }

  @media (max-width: ${breakpointMdSmall}) {
    padding: 12px 16px 12px 20px;
  }
`;

const CtaButtonText = styled.span`
  ${title03}

  display: flex;
  align-items: center;
  gap: 8px;
`;
